import { render } from "./WrpOne.vue?vue&type=template&id=22b38674&scoped=true"
import script from "./WrpOne.vue?vue&type=script&lang=js"
export * from "./WrpOne.vue?vue&type=script&lang=js"

import "./WrpOne.vue?vue&type=style&index=0&id=22b38674&scoped=true&lang=scss"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b38674"]])

export default __exports__